import FilterDialog from './Dialog'
import { useSelector } from 'react-redux'
import FilterButton from '../../../../filter/FilterButton'

const FilterButtonMaintenance = () => {
  const open = useSelector(state => state?.filter?.maintenance?.open || false)

  return (
    <>
      <FilterButton 
        module='maintenance' 
      />
      { open &&
        <FilterDialog />
      }
    </>
  )
}
export default FilterButtonMaintenance